<div class="pb-[40px]">
  <div class="flex justify-between items-center w-full px-[50px] !py-[23px]">
    <!-- Header on the left -->
    <div class="header h-[55px] flex items-center pl-[14px]">
      <p class="!m-0">
        {{ projectName }} - Pre-Qualification Questionnaire (PQQ)
      </p>
    </div>

    <div class="flex items-center">
      <div class="container-fluid !pr-[10px] bg-[#ffffff]">
        <div class="flex justify-end">
          <div
            class="rounded relative w-[fit-content]"
            (mouseenter)="tooltipVisibilityToggle()"
            (mouseleave)="tooltipVisibilityToggle()"
          >
            <button
              *ngIf="isCreator"
              class="primary-action-btn !text-[#ffffff] !text-[16px] !px-[25px]"
              [ngClass]="
                submittedInitiation?.is_initiated === 1 ||
                (submittedInitiation?.is_initiated === 0 &&
                  approvalsStatus !== 'approved')
                  ? '!bg-[#868E96] !border-none'
                  : ''
              "
              type="button"
              (click)="sendInvitations()"
              aria-describedby="tooltip"
              [disabled]="
                submittedInitiation?.is_initiated === 1 ||
                approvalsStatus === 'pending'
                  ? true
                  : false
              "
            >
              {{ !submittedInitiation?.is_initiated ? "Initiate" : "Initiated" }}
            </button>
          </div>
        </div>
        <div
          class="flex justify-end relative"
          *ngIf="showTooltip && approvalsStatus === 'pending'"
        >
          <app-custom-tooltip
            [toolTipMessage]="toolTipMessage?.INITIATE_DISABLE"
          ></app-custom-tooltip>
        </div>
      </div>
      <button (click)="handleClose()" type="button" class="close-btn">
        Close
      </button>

      <button
        *ngIf="isCreator && !submittedInitiation?.is_initiated"
        (click)="handleEdit()"
        type="button"
        class="edit-btn"
      >
        Edit
      </button>
      <button
        *ngIf="isCreator"
        (click)="handleApprovals()"
[ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : '' "
        type="button"
        class="primary-action-btn"
      >
        {{ approvalResponses ? "Approval Status" : "Send For Approvals" }}
      </button>
      <button
        *ngIf="
          !checkApprove &&
          internalApproval?.internal_approvals !== null &&
          isInApprovers
        "
        (click)="approvalResponseView(pqqId, projectId)"
        type="button"
        class="primary-action-btn"
      >
        Approval Requested
      </button>
      <button
        *ngIf="checkApprove && isInApprovers"
        (click)="handleApprovals()"
        [ngClass]="approvalsStatus === 'approved' ? '!bg-[#197741] !border-[#197741]' : approvalsStatus === 'rejected' ? '!bg-[#ff0000] !border-[#ff0000]' : '' "
        type="button"
        class="primary-action-btn cursor-pointer"
      >
        Approval Sent
      </button>
    </div>
  </div>

  <div
    class="header h-[55px] flex justify-start items-center mx-[50px] pl-[14px] bg-[#F1F3F5]"
  >
    <p class="!m-0">Receiver Organizations Details</p>
  </div>
  <div class="mx-[50px] mt-[24px]">
    <div
      class="!mb-[1.3rem] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 table-scrolling"
    >
      <div class="!w-[100%] flex items-center">
        <table class="!w-[100%] bg-[#fcfcfd] table-auto">
          <thead
            class="h-[52px] !bg-[#DEE2E6] text-[#000000] !text-left justify-left py-2 sticky top-0 !z-20"
          >
            <tr class="height-[36px]">
              <th class="px-4 py-2 text-left">Company</th>
              <th class="px-4 py-2 text-left">Name</th>
              <th class="px-4 py-2 text-left">Email</th>
              <th class="px-4 py-2 text-left">Position</th>
              <th class="px-4 py-2 text-center">Status</th>
            </tr>
          </thead>
          <tbody style="margin-right: 0px; overflow-y: auto">
            <ng-container
              *ngFor="let orgDetail of enrichedOrganizations; let i = index"
            >
              <tr
                class="!h-[52px] hover:bg-gray-200 border-b-0 items-center justify-center cursor-pointer"
                [ngClass]="{
                  'bg-white': i % 2 === 0,
                  'bg-[#DEE2E6]': i % 2 !== 0
                }"
                (click)="
                  openIndividualPQQResponsePreview(orgDetail?.response?.id)
                "
              >
                <td class="border-b-0 px-4 py-2 text-left">
                  {{
                    orgDetail?.receiving_org_id
                      ? orgDetail?.applicant_organization?.name
                      : orgDetail?.external_company_name
                  }}
                </td>
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.name }}
                </td>
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.email }}
                </td>
                <td class="border-b-0 px-4 py-2 text-left">
                  {{ orgDetail?.position }}
                </td>
                <td class="border-b-0 text-center">
                  <span
                    [ngClass]="{
                    'status-received':
                      orgDetail?.response?.status === 'Received',
                    'status-pending':
                      orgDetail?.response?.status === 'pending',
                      'status-submitted':
                      orgDetail?.response?.status === 'submitted',

                  }"
                  >
                    {{ orgDetail?.response?.status | titlecase }}
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.3rem] bg-[#F1F3F5]"
    >
      <p class="!m-0">Receiver Side Preview</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[15px]">
      <app-brief-section></app-brief-section>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.3rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[12px]">
        <div
          *ngFor="
            let orgDetail of submittedInitiation?.selected_work_packages;
            let i = index
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <img
              src="assets/icons/checkbox.png"
              class="h-[20px] w-[20px] mr-[12px]"
              alt="checkbox"
            />
            <p class="packages-name">{{ orgDetail?.name }}</p>
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.3rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Submission Guidlines</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]"
      >
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[196px]"
          >
            Reference Number
          </div>
          <div
            class="text-black font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedInitiation?.reference_number }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[196px]"
          >
            Client /Authority
          </div>
          <div
            class="text-black font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedInitiation?.client }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[196px]"
          >
            Date Issued
          </div>
          <div
            class="text-black font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedInitiation?.issue_date }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] font-semibold leading-normal !w-[196px]"
          >
            Submissions Deadline
          </div>
          <div
            class="text-black font-roboto text-[14px] font-normal leading-normal"
          >
            {{ submittedInitiation?.submission_deadline }}
          </div>
        </div>
      </div>
    </div>
    <div
    class="header h-[55px] flex justify-start items-center mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[10px] !pr-[30px]">Show Templates</p>
    <button (click)="showTemplateForm = !showTemplateForm" 
    class="flex items-center justify-center toggleButton p-2 ">
    
    <div class="w-12 h-6 pr-[5px] bg-gray-300 rounded-full relative toggle-button"
         [class.active]="showTemplateForm">
         
        <div class="w-6 h-6 bg-white rounded-full absolute transition-all duration-300"
             [class.translate-x-6]="showTemplateForm">
        </div>
        </div>

      </button>
  </div>
<div *ngIf="showTemplateForm">
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[0.3rem] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">PQQ forms and Templates</p>
    </div>
    <div class="w-[100%] pt-[3px]">
      <app-pqq-read-only-form></app-pqq-read-only-form>
    </div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[1rem] mb-[0.3rem] bg-[#F1F3F5]"
    >
      <p class="!m-0">Disclaimer</p>
    </div>
    <p class="breif-value text-justify">
      The submission of this PQQ does not constitute a binding agreement or
      obligation for the applicant or the issuing organization. The information
      provided in this form is for evaluation purposes only and will be treated
      confidentially. However, the issuing organization reserves the right to
      verify the details provided and may use this information as part of the
      selection process. Submission of this PQQ does not guarantee shortlisting,
      approval, or further communication. The issuing organization reserves the
      right to accept, reject, or request additional information without
      assigning any reason. By submitting this form, the applicant acknowledges
      and agrees to these terms.
    </p>
  </div>
  </div>
</div>

<ng-container *ngIf="isEdit">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [isEdit]="isEdit"
  ></app-wrapper>
</ng-container>
